import muiSelectItemModuleCss from '../../../assets/css/mui.select.menue-item.module.css';
import { MenuItem } from "@material-ui/core";
import React from 'react';


type Param = {
    value?: string | ReadonlyArray<string> | number;
}

const SelectMenuItem: React.FC<Param> = React.forwardRef((props, ref) => {
    const { value, children, ...other } = props;
    return (
        <MenuItem value={value} innerRef={ref}
            classes={muiSelectItemModuleCss} {...other}>{children}</MenuItem>
    );
});

export default SelectMenuItem;